import { handleApiError } from '@api';
import config from '@config';
import { HTTPClient } from '@platform2-lib/httpz';
import * as schema from '@schema';
import type { AgentVersionsResponse, Dataset, PromptUsage } from 'types/schema';

const client = new HTTPClient(
  config.env,
  `${config.api.origin}/spark-agent-v2`
);

const getAgentVersions = async (): Promise<AgentVersionsResponse> => {
  try {
    const response = await client.get(
      '/agents/versions',
      schema.AgentVersionsResponse
    );

    return response;
  } catch (error: unknown) {
    handleApiError(error, 'Failed to retrieve agent versions.');
  }
};

const getAccessibleDatasets = async (): Promise<Dataset[]> => {
  try {
    const { datasets } = await client.get(
      '/datasets',
      schema.DatasetAccessResponse
    );

    return datasets;
  } catch (error: unknown) {
    handleApiError(error, 'Failed to retrieve dataset access.');

    return [];
  }
};

const getPromptUsage = async (): Promise<PromptUsage> => {
  try {
    const response = await client.get('/chat/usage', schema.PromptUsage);

    return response;
  } catch (error: unknown) {
    handleApiError(error, 'Failed to retrieve the current quota.');

    return { ['usage_remaining']: -1 };
  }
};

export const user = {
  getAgentVersions,
  getAccessibleDatasets,
  getPromptUsage
};
